import { adminHttp } from "./admin.http";

export type UserRole = "USER" | "ADMIN" | "SUPERADMIN";

export type LoginResponse = {
  access_token: string;
  user: {
    _id: string;
    username: string;
    coins: number;
    role: UserRole;
  };
};

export async function adminLogin(params: { username: string; password: string }) {
  const res = await adminHttp.post<LoginResponse>("/auth/admin/login", params);
  return res.data;
}

export async function getUsers(role: UserRole) {
  const uri = role === "ADMIN" ? "/users" : "/users/all";
  const res = await adminHttp.get(uri);
  return res.data as any[];
}

export async function deleteUser(userId: string) {
  const res = await adminHttp.delete(`/users/${userId}`);
  return res.data;
}

export async function updateUser(userId: string, payload: { username: string; phone: string; password?: string }) {
  const res = await adminHttp.put(`/users/${userId}`, payload);
  return res.data;
}

export async function createUserBySuperAdmin(payload: { username: string; password: string; phone: string; role: UserRole }) {
  const res = await adminHttp.post(`/users`, payload);
  return res.data;
}

export async function createUserByAdmin(payload: { username: string; password: string; phone: string; managedByUsername: string }) {
  const res = await adminHttp.post(`/auth/register`, payload);
  return res.data;
}

export async function addCoins(userId: string, amount: number) {
  const res = await adminHttp.post(`/users/${userId}/add-coins`, { amount });
  return res.data;
}

export async function subtractCoins(userId: string, amount: number) {
  const res = await adminHttp.post(`/users/${userId}/subtract-coins`, { amount });
  return res.data;
}

export type AdminAccount = {
  _id: string;
  username: string;
  role: UserRole;
  coins?: number;
  phone?: string;
};

export type AdminLatestCode = {
  code: string;
  adminUsername: string;
  adminId: string;
  expiresAt: string | null;
  createdAt: string;
  isExpired: boolean;
};

export async function getAdminAccounts() {
  const res = await adminHttp.get<AdminAccount[]>("/users/admins");
  return res.data;
}

export async function getLatestAdminCodes() {
  const res = await adminHttp.get<AdminLatestCode[]>("/auth/admin/codes/latest");
  return res.data;
}

export async function generateCode(expiresInDays = 30) {
  const res = await adminHttp.post("/auth/admin/generate-code", { expiresInDays });
  return res.data as { code: string; adminUsername: string; adminId: string; expiresAt: string | null };
}

export async function generateCodeFor(adminId: string, expiresInDays = 30) {
  const res = await adminHttp.post(`/auth/admin/generate-code-for/${adminId}`, { expiresInDays });
  return res.data as { code: string; adminUsername: string; adminId: string; expiresAt: string | null };
}

